import React from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/#poker-101", label: "POKER 101", testid: "nav-poker-101" },
  { to: "/#lucas-style", label: "POKER LUCAS STYLE", testid: "nav-poker-lucas" },
  { to: "/#bootcamp", label: "BOOT CAMP", testid: "nav-bootcamp" },
  { to: "/#merch", label: "ALL ABOUT THE MERCH", testid: "nav-merch" },
  { to: "/#faq", label: "FAQ", testid: "nav-faq" },
];

export default function Navbar() {
  const location = useLocation();

  const isActive = (to) => {
    if (to.startsWith("/#")) return false;
    return location.pathname === to;
  };

  return (
    <header className="sticky top-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 shrink-0">
          <span className="font-bebas text-2xl text-white leading-none">
            LUCAS<span className="text-gold-400">JUMALON</span>POKER<span className="text-gold-400">.AI</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-2 flex-wrap justify-end">
          {NAV_ITEMS.map((item) => {
            const active = isActive(item.to);
            const cls = `inline-flex items-center justify-center px-3 py-1.5 font-bebas tracking-wider uppercase rounded-none border transition-colors ${
              active
                ? "border-scarcity text-scarcity bg-scarcity/10"
                : "border-gold-400/60 text-gold-400 bg-transparent hover:bg-scarcity/10 hover:border-scarcity hover:text-scarcity"
            }`;
            const inner = <span style={{ fontSize: "13px" }}>{item.label}</span>;
            return item.to.startsWith("/#") ? (
              <a key={item.to} href={item.to} data-testid={item.testid} className={cls}>
                {inner}
              </a>
            ) : (
              <Link key={item.to} to={item.to} data-testid={item.testid} className={cls}>
                {inner}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
